// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-debug-tsx": () => import("/opt/build/repo/src/pages/debug.tsx" /* webpackChunkName: "component---src-pages-debug-tsx" */),
  "component---src-pages-index-tsx": () => import("/opt/build/repo/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-mobile-tsx": () => import("/opt/build/repo/src/pages/mobile.tsx" /* webpackChunkName: "component---src-pages-mobile-tsx" */)
}

